var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.88,15.3V25.72h-7.5V23.637H9.88V25.72h-7V15.3Zm-4.525-1.9A6.02,6.02,0,0,0,17.4,10.071c-.989-.856-2.158-1.018-3.515-1.539H13.88v-3.3l.262-.073.573-.221a5.343,5.343,0,0,1,.628-.189,1.98,1.98,0,0,1,.443-.072,3.3,3.3,0,0,1,.706.095c.284.072.587.149.894.238s.607.178.884.243a2.917,2.917,0,0,0,.67.089,4.655,4.655,0,0,0,.941-.134V1.439a3.3,3.3,0,0,1-.941.192,2.7,2.7,0,0,1-.676-.1c-.277-.055-.561-.141-.882-.238q-.429-.134-.866-.232a2.564,2.564,0,0,0-.64-.1,4.522,4.522,0,0,0-2,.446V.72h-1V8.533h-.031c-1.346.521-2.524.712-3.512,1.568a6.071,6.071,0,0,0-1.959,3.261.82.82,0,0,0-.958.9H20.4c0-1.042-1.05-.857-1.05-.857Z",
    transform: "translate(-2.88 -0.72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.09042608aa185255a3806954be1dde56.svg";
export { ForwardRef as ReactComponent };